// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../intl/Intl_Utils.bs.js";
import * as Route_Paths$DvmAdminFrontendFr from "../../../route/Route_Paths.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../intl/messages/Messages_Common.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../common/types/App_Types_Result.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../context/user/User_Types_Utils.bs.js";
import * as Model_Version_Form$DvmAdminFrontendFr from "../../modelVersionList/Model_Version_Form.bs.js";
import * as Messages_Orders_Modal$DvmAdminFrontendFr from "../../../intl/messages/orders/Messages_Orders_Modal.bs.js";
import * as Messages_Orders_Detail$DvmAdminFrontendFr from "../../../intl/messages/orders/Messages_Orders_Detail.bs.js";
import * as Messages_FinancialCodes$DvmAdminFrontendFr from "../../../intl/messages/easypack/Messages_FinancialCodes.bs.js";

function isAgentZero(agentCode) {
  return agentCode === "000";
}

function isStringEmpty(someString) {
  return Belt_Option.mapWithDefault(someString, true, (function (x) {
                return x.length === 0;
              }));
}

function isFloatEmptyOrZero(someFloat) {
  return Belt_Option.mapWithDefault(someFloat, true, (function (x) {
                return x === 0.0;
              }));
}

function spainHeaders(clientTypes, salesTypes, order) {
  var getClientTypeLabel = function (clientType) {
    return App_Types_Result$DvmAdminFrontendFr.mapWithDefault(clientTypes, "", (function (x) {
                  return Belt_Option.mapWithDefault(Belt_List.getBy(x, (function (item) {
                                    return item.paramOne === clientType;
                                  })), "", (function (found) {
                                return Belt_Option.mapWithDefault(found.paramTwo, "", (function (label) {
                                              return " - " + label;
                                            }));
                              }));
                }));
  };
  var getSaleTypeLabel = function (saleType) {
    return App_Types_Result$DvmAdminFrontendFr.mapWithDefault(salesTypes, "", (function (x) {
                  return Belt_Option.mapWithDefault(Belt_List.getBy(x, (function (item) {
                                    return item.paramOne === saleType;
                                  })), "", (function (found) {
                                return Belt_Option.mapWithDefault(found.paramTwo, "", (function (label) {
                                              return " - " + label;
                                            }));
                              }));
                }));
  };
  return [
          {
            label: Messages_Common$DvmAdminFrontendFr.clientType,
            val: Belt_Option.mapWithDefault(order.body.orderClientType, "-", (function (x) {
                    if (x.length > 0) {
                      return x + getClientTypeLabel(x);
                    } else {
                      return "-";
                    }
                  }))
          },
          {
            label: Messages_Common$DvmAdminFrontendFr.saleType,
            val: Belt_Option.mapWithDefault(order.body.orderSaleType, "-", (function (x) {
                    if (x.length > 0) {
                      return x + getSaleTypeLabel(x);
                    } else {
                      return "-";
                    }
                  }))
          }
        ];
}

function headerArray(order, selectedRole, actualOrderType, param) {
  return Belt_List.toArray(Belt_List.keepMap({
                  hd: {
                    label: Messages_Common$DvmAdminFrontendFr.territory,
                    val: Belt_Option.getWithDefault(order.header.orderDr, "-")
                  },
                  tl: {
                    hd: {
                      label: Messages_Common$DvmAdminFrontendFr.dealerID,
                      val: Belt_Option.getWithDefault(order.header.orderDealerId, "-")
                    },
                    tl: {
                      hd: {
                        label: Messages_Orders_Detail$DvmAdminFrontendFr.dealerName,
                        val: Belt_Option.getWithDefault(order.body.dealerLocationCommonName, "-")
                      },
                      tl: {
                        hd: {
                          label: Messages_Orders_Detail$DvmAdminFrontendFr.dealerCompanyName,
                          val: Belt_Option.getWithDefault(order.header.dealerName, "-")
                        },
                        tl: {
                          hd: {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.customerOrderNum,
                            val: Belt_Option.getWithDefault(order.header.orderCustomerOrderNumber, "-")
                          },
                          tl: {
                            hd: {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.carOrderNum,
                              val: Belt_Option.getWithDefault(order.header.orderCarOrderNumber, "-")
                            },
                            tl: {
                              hd: User_Types_Utils$DvmAdminFrontendFr.whatCountry(selectedRole) === /* France */0 ? ({
                                    label: Messages_Common$DvmAdminFrontendFr.orderType,
                                    val: Belt_Option.mapWithDefault(Belt_Option.mapWithDefault(actualOrderType, order.header.orderOrderType, (function (x) {
                                                return x;
                                              })), "-", (function (x) {
                                            switch (x) {
                                              case /* SO */0 :
                                                  return "SO - Societé";
                                              case /* CL */1 :
                                                  return "CL - Particulier";
                                              case /* VE */2 :
                                                  return "VE - PARC";
                                              case /* VD */3 :
                                                  return "VD - Véhicule de démonstration agent";
                                              case /* RR */4 :
                                                  return "RR - PARC";
                                              case /* RC */5 :
                                                  return "RC - PARC";
                                              case /* PG */6 :
                                                  return "PG - Vente au personnel";
                                              case /* EP */7 :
                                                  return "EP - Essai Particulier";
                                              case /* ES */8 :
                                                  return "ES - Essai Société";
                                              case /* RP */9 :
                                                  return "RP - Rent Particulier";
                                              case /* RS */10 :
                                                  return "RS - Rent Société";
                                              case /* SM */11 :
                                                  return "SM - Vente Directe RPE";
                                              case /* TT */12 :
                                                  return "TT - EURODRIVE";
                                              case /* AD */13 :
                                                  return "AD - Démonstration Agent";
                                              case /* AP */14 :
                                                  return "AP - Agent Particulier";
                                              case /* AS */15 :
                                                  return "AS - Agent Société";
                                              case /* NOTSET */16 :
                                                  return "";
                                              
                                            }
                                          }))
                                  }) : undefined,
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }, (function (x) {
                    return x;
                  })));
}

function modelOnClick(model, dispatch) {
  return Belt_Option.mapWithDefault(model, undefined, (function (model) {
                return (function (param) {
                          Curry._1(dispatch, {
                                TAG: /* StoreModelVersionFilter */2,
                                _0: {
                                  brand: Model_Version_Form$DvmAdminFrontendFr.initialState.brand,
                                  model: model,
                                  version: Model_Version_Form$DvmAdminFrontendFr.initialState.version,
                                  phase: Model_Version_Form$DvmAdminFrontendFr.initialState.phase,
                                  modelLabel: Model_Version_Form$DvmAdminFrontendFr.initialState.modelLabel,
                                  versionLabel: Model_Version_Form$DvmAdminFrontendFr.initialState.versionLabel,
                                  motorization: Model_Version_Form$DvmAdminFrontendFr.initialState.motorization,
                                  emptyMotorization: Model_Version_Form$DvmAdminFrontendFr.initialState.emptyMotorization,
                                  active: Model_Version_Form$DvmAdminFrontendFr.initialState.active,
                                  tableType: /* Model */0,
                                  additionDate: Model_Version_Form$DvmAdminFrontendFr.initialState.additionDate
                                }
                              });
                          RescriptReactRouter.push(Route_Paths$DvmAdminFrontendFr.rView + Route_Paths$DvmAdminFrontendFr.rModelVersionList);
                        });
              }));
}

function versionOnClick(model, version, dispatch) {
  if (model !== undefined && version !== undefined) {
    return (function (param) {
              Curry._1(dispatch, {
                    TAG: /* StoreModelVersionFilter */2,
                    _0: {
                      brand: Model_Version_Form$DvmAdminFrontendFr.initialState.brand,
                      model: model,
                      version: version,
                      phase: Model_Version_Form$DvmAdminFrontendFr.initialState.phase,
                      modelLabel: Model_Version_Form$DvmAdminFrontendFr.initialState.modelLabel,
                      versionLabel: Model_Version_Form$DvmAdminFrontendFr.initialState.versionLabel,
                      motorization: Model_Version_Form$DvmAdminFrontendFr.initialState.motorization,
                      emptyMotorization: Model_Version_Form$DvmAdminFrontendFr.initialState.emptyMotorization,
                      active: Model_Version_Form$DvmAdminFrontendFr.initialState.active,
                      tableType: /* Version */1,
                      additionDate: Model_Version_Form$DvmAdminFrontendFr.initialState.additionDate
                    }
                  });
              RescriptReactRouter.push(Route_Paths$DvmAdminFrontendFr.rView + Route_Paths$DvmAdminFrontendFr.rModelVersionList);
            });
  }
  
}

function orderDetail(order, intl, selectedRole, dispatch) {
  return Belt_Option.mapWithDefault(order.header.orderOrderType, [], (function (orderType) {
                if (orderType !== 11 && orderType !== 0) {
                  var delivered = Belt_Option.getWithDefault(order.body.resultDelivered, false);
                  var tmp;
                  var exit = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp = isStringEmpty(order.body.orderCustomerName);
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit = 2;
                        break;
                    default:
                      tmp = isStringEmpty(order.body.orderCustomerName);
                  }
                  if (exit === 2) {
                    tmp = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isStringEmpty(order.body.orderCustomerName) : false;
                  }
                  var tmp$1;
                  var exit$1 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp$1 = isStringEmpty(order.body.orderModelId);
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$1 = 2;
                        break;
                    default:
                      tmp$1 = isStringEmpty(order.body.orderModelId);
                  }
                  if (exit$1 === 2) {
                    tmp$1 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isStringEmpty(order.body.orderModelId) : false;
                  }
                  var tmp$2;
                  var exit$2 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp$2 = isStringEmpty(order.body.orderVersionId);
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$2 = 2;
                        break;
                    default:
                      tmp$2 = isStringEmpty(order.body.orderVersionId);
                  }
                  if (exit$2 === 2) {
                    tmp$2 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isStringEmpty(order.body.orderVersionId) : false;
                  }
                  var tmp$3;
                  var exit$3 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp$3 = false;
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$3 = 2;
                        break;
                    default:
                      tmp$3 = false;
                  }
                  if (exit$3 === 2) {
                    tmp$3 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isStringEmpty(order.body.orderRegistrationId) : false;
                  }
                  var tmp$4;
                  var exit$4 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp$4 = isStringEmpty(order.body.orderVIN);
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$4 = 2;
                        break;
                    default:
                      tmp$4 = isStringEmpty(order.body.orderVIN);
                  }
                  if (exit$4 === 2) {
                    tmp$4 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isStringEmpty(order.body.orderVIN) : false;
                  }
                  var tmp$5;
                  var exit$5 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp$5 = Belt_Option.isNone(order.body.orderOrderDate);
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$5 = 2;
                        break;
                    default:
                      tmp$5 = Belt_Option.isNone(order.body.orderOrderDate);
                  }
                  if (exit$5 === 2) {
                    tmp$5 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? Belt_Option.isNone(order.body.orderOrderDate) : false;
                  }
                  var tmp$6;
                  var exit$6 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp$6 = false;
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$6 = 2;
                        break;
                    default:
                      tmp$6 = false;
                  }
                  if (exit$6 === 2) {
                    tmp$6 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? Belt_Option.isNone(order.body.orderRegistrationDate) : false;
                  }
                  var tmp$7;
                  var exit$7 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        exit$7 = 3;
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$7 = 2;
                        break;
                    default:
                      exit$7 = 3;
                  }
                  switch (exit$7) {
                    case 2 :
                        tmp$7 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? Belt_Option.isNone(order.body.resultDeliveryDate) : false;
                        break;
                    case 3 :
                        tmp$7 = delivered || Belt_Option.isSome(order.usedCar) ? Belt_Option.isNone(order.body.resultDeliveryDate) : false;
                        break;
                    
                  }
                  var tmp$8;
                  var exit$8 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp$8 = Belt_Option.isNone(order.body.orderMADCDate);
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$8 = 2;
                        break;
                    default:
                      tmp$8 = Belt_Option.isNone(order.body.orderMADCDate);
                  }
                  if (exit$8 === 2) {
                    tmp$8 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? Belt_Option.isNone(order.body.orderMADCDate) : false;
                  }
                  var tmp$9;
                  var exit$9 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp$9 = Belt_Option.isNone(order.body.orderMADADate);
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$9 = 2;
                        break;
                    default:
                      tmp$9 = Belt_Option.isNone(order.body.orderMADADate);
                  }
                  if (exit$9 === 2) {
                    tmp$9 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? Belt_Option.isNone(order.body.orderMADADate) : false;
                  }
                  var tmp$10;
                  var exit$10 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp$10 = isStringEmpty(order.body.advensysInvoiceNumber);
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$10 = 2;
                        break;
                    default:
                      tmp$10 = isStringEmpty(order.body.advensysInvoiceNumber);
                  }
                  if (exit$10 === 2) {
                    tmp$10 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isStringEmpty(order.body.advensysInvoiceNumber) : false;
                  }
                  var tmp$11;
                  var exit$11 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp$11 = Belt_Option.isNone(order.body.orderRenaultInvoiceDate);
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$11 = 2;
                        break;
                    default:
                      tmp$11 = Belt_Option.isNone(order.body.orderRenaultInvoiceDate);
                  }
                  if (exit$11 === 2) {
                    tmp$11 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? Belt_Option.isNone(order.body.orderRenaultInvoiceDate) : false;
                  }
                  var tmp$12;
                  var exit$12 = 0;
                  switch (orderType) {
                    case /* VD */3 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                        tmp$12 = isStringEmpty(order.body.advensysTariffNumber);
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$12 = 2;
                        break;
                    default:
                      tmp$12 = isStringEmpty(order.body.advensysTariffNumber);
                  }
                  if (exit$12 === 2) {
                    tmp$12 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isStringEmpty(order.body.advensysTariffNumber) : false;
                  }
                  var match = Belt_Option.getWithDefault(order.body.advensysPVCHT, 0.0);
                  var match$1 = Belt_Option.getWithDefault(order.body.resultCAHT, 0.0);
                  var tmp$13;
                  if (match !== 0.0) {
                    var tmp$14;
                    var exit$13 = 0;
                    switch (orderType) {
                      case /* CL */1 :
                          tmp$14 = false;
                          break;
                      case /* VE */2 :
                      case /* RR */4 :
                      case /* RC */5 :
                      case /* AD */13 :
                          exit$13 = 2;
                          break;
                      case /* SO */0 :
                      case /* VD */3 :
                      case /* PG */6 :
                      case /* EP */7 :
                      case /* ES */8 :
                      case /* RP */9 :
                      case /* RS */10 :
                      case /* SM */11 :
                      case /* TT */12 :
                      case /* AP */14 :
                      case /* AS */15 :
                      case /* NOTSET */16 :
                          tmp$14 = isFloatEmptyOrZero(order.body.advensysPVCHT);
                          break;
                      
                    }
                    if (exit$13 === 2) {
                      tmp$14 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isFloatEmptyOrZero(order.body.advensysPVCHT) : false;
                    }
                    tmp$13 = {
                      label: Messages_Orders_Detail$DvmAdminFrontendFr.priceRefVNV2,
                      val: Belt_Option.mapWithDefault(order.body.advensysPVCHT, "-", (function (x) {
                              if (x > 0.0) {
                                return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
                              } else {
                                return "-";
                              }
                            })),
                      error: tmp$14
                    };
                  } else if (match$1 !== 0.0) {
                    var tmp$15;
                    var exit$14 = 0;
                    switch (orderType) {
                      case /* VD */3 :
                      case /* PG */6 :
                      case /* EP */7 :
                      case /* ES */8 :
                      case /* RP */9 :
                      case /* RS */10 :
                      case /* SM */11 :
                      case /* TT */12 :
                          exit$14 = 3;
                          break;
                      case /* VE */2 :
                      case /* RR */4 :
                      case /* RC */5 :
                      case /* AD */13 :
                          exit$14 = 2;
                          break;
                      default:
                        exit$14 = 3;
                    }
                    switch (exit$14) {
                      case 2 :
                          tmp$15 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isFloatEmptyOrZero(order.body.resultCAHT) : false;
                          break;
                      case 3 :
                          tmp$15 = delivered || Belt_Option.isSome(order.usedCar) ? isFloatEmptyOrZero(order.body.resultCAHT) : false;
                          break;
                      
                    }
                    tmp$13 = {
                      label: Messages_Orders_Detail$DvmAdminFrontendFr.priceCaHt,
                      val: Belt_Option.mapWithDefault(order.body.resultCAHT, "-", (function (x) {
                              if (x > 0.0) {
                                return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
                              } else {
                                return "-";
                              }
                            })),
                      error: tmp$15
                    };
                  } else {
                    var tmp$16;
                    var exit$15 = 0;
                    switch (orderType) {
                      case /* CL */1 :
                          tmp$16 = false;
                          break;
                      case /* VE */2 :
                      case /* RR */4 :
                      case /* RC */5 :
                      case /* AD */13 :
                          exit$15 = 2;
                          break;
                      case /* SO */0 :
                      case /* VD */3 :
                      case /* PG */6 :
                      case /* EP */7 :
                      case /* ES */8 :
                      case /* RP */9 :
                      case /* RS */10 :
                      case /* SM */11 :
                      case /* TT */12 :
                      case /* AP */14 :
                      case /* AS */15 :
                      case /* NOTSET */16 :
                          tmp$16 = isFloatEmptyOrZero(order.body.advensysPVCHT);
                          break;
                      
                    }
                    if (exit$15 === 2) {
                      tmp$16 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isFloatEmptyOrZero(order.body.advensysPVCHT) : false;
                    }
                    tmp$13 = {
                      label: Messages_Orders_Detail$DvmAdminFrontendFr.priceRefVNV2,
                      val: Belt_Option.mapWithDefault(order.body.advensysPVCHT, "-", (function (x) {
                              if (x > 0.0) {
                                return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
                              } else {
                                return "-";
                              }
                            })),
                      error: tmp$16
                    };
                  }
                  var match$2 = Belt_Option.getWithDefault(order.body.advensysPVCTTC, 0.0);
                  var match$3 = Belt_Option.getWithDefault(order.body.orderCATTC, 0.0);
                  var tmp$17;
                  if (match$2 !== 0.0) {
                    var tmp$18;
                    var exit$16 = 0;
                    switch (orderType) {
                      case /* VD */3 :
                      case /* PG */6 :
                      case /* EP */7 :
                      case /* ES */8 :
                      case /* RP */9 :
                      case /* RS */10 :
                      case /* SM */11 :
                      case /* TT */12 :
                          exit$16 = 3;
                          break;
                      case /* VE */2 :
                      case /* RR */4 :
                      case /* RC */5 :
                      case /* AD */13 :
                          exit$16 = 2;
                          break;
                      default:
                        exit$16 = 3;
                    }
                    switch (exit$16) {
                      case 2 :
                          tmp$18 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isFloatEmptyOrZero(order.body.advensysPVCTTC) : false;
                          break;
                      case 3 :
                          tmp$18 = delivered || Belt_Option.isSome(order.usedCar) ? false : isFloatEmptyOrZero(order.body.advensysPVCTTC);
                          break;
                      
                    }
                    tmp$17 = {
                      label: Messages_Orders_Detail$DvmAdminFrontendFr.pvcTtc,
                      val: Belt_Option.mapWithDefault(order.body.advensysPVCTTC, "-", (function (x) {
                              if (x > 0.0) {
                                return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
                              } else {
                                return "-";
                              }
                            })),
                      error: tmp$18
                    };
                  } else if (match$3 !== 0.0) {
                    var tmp$19;
                    var exit$17 = 0;
                    switch (orderType) {
                      case /* VD */3 :
                      case /* PG */6 :
                      case /* EP */7 :
                      case /* ES */8 :
                      case /* RP */9 :
                      case /* RS */10 :
                      case /* SM */11 :
                      case /* TT */12 :
                          exit$17 = 3;
                          break;
                      case /* VE */2 :
                      case /* RR */4 :
                      case /* RC */5 :
                      case /* AD */13 :
                          exit$17 = 2;
                          break;
                      default:
                        exit$17 = 3;
                    }
                    switch (exit$17) {
                      case 2 :
                          tmp$19 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isFloatEmptyOrZero(order.body.orderCATTC) : false;
                          break;
                      case 3 :
                          tmp$19 = delivered || Belt_Option.isSome(order.usedCar) ? isFloatEmptyOrZero(order.body.orderCATTC) : false;
                          break;
                      
                    }
                    tmp$17 = {
                      label: Messages_Orders_Detail$DvmAdminFrontendFr.priceCaTTC,
                      val: Belt_Option.mapWithDefault(order.body.orderCATTC, "-", (function (x) {
                              if (x > 0.0) {
                                return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
                              } else {
                                return "-";
                              }
                            })),
                      error: tmp$19
                    };
                  } else {
                    var tmp$20;
                    var exit$18 = 0;
                    switch (orderType) {
                      case /* VD */3 :
                      case /* PG */6 :
                      case /* EP */7 :
                      case /* ES */8 :
                      case /* RP */9 :
                      case /* RS */10 :
                      case /* SM */11 :
                      case /* TT */12 :
                          exit$18 = 3;
                          break;
                      case /* VE */2 :
                      case /* RR */4 :
                      case /* RC */5 :
                      case /* AD */13 :
                          exit$18 = 2;
                          break;
                      default:
                        exit$18 = 3;
                    }
                    switch (exit$18) {
                      case 2 :
                          tmp$20 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isFloatEmptyOrZero(order.body.advensysPVCTTC) : false;
                          break;
                      case 3 :
                          tmp$20 = delivered || Belt_Option.isSome(order.usedCar) ? false : isFloatEmptyOrZero(order.body.advensysPVCTTC);
                          break;
                      
                    }
                    tmp$17 = {
                      label: Messages_Orders_Detail$DvmAdminFrontendFr.pvcTtc,
                      val: Belt_Option.mapWithDefault(order.body.advensysPVCTTC, "-", (function (x) {
                              if (x > 0.0) {
                                return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
                              } else {
                                return "-";
                              }
                            })),
                      error: tmp$20
                    };
                  }
                  var tmp$21;
                  var exit$19 = 0;
                  switch (orderType) {
                    case /* CL */1 :
                    case /* VD */3 :
                        tmp$21 = false;
                        break;
                    case /* VE */2 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* AD */13 :
                        exit$19 = 2;
                        break;
                    case /* SO */0 :
                    case /* PG */6 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                    case /* TT */12 :
                    case /* AP */14 :
                    case /* AS */15 :
                    case /* NOTSET */16 :
                        exit$19 = 3;
                        break;
                    
                  }
                  switch (exit$19) {
                    case 2 :
                        tmp$21 = Belt_Option.isSome(order.body.resultCalcPARCStartDate) ? isFloatEmptyOrZero(order.body.advensysNETPVR) : false;
                        break;
                    case 3 :
                        tmp$21 = delivered || Belt_Option.isSome(order.usedCar) ? isFloatEmptyOrZero(order.body.advensysNETPVR) : false;
                        break;
                    
                  }
                  var tmp$22;
                  switch (orderType) {
                    case /* VE */2 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                        tmp$22 = Messages_Common$DvmAdminFrontendFr.discount;
                        break;
                    case /* CL */1 :
                    case /* VD */3 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* PG */6 :
                    case /* TT */12 :
                        tmp$22 = Messages_Common$DvmAdminFrontendFr.discountTTC;
                        break;
                    default:
                      tmp$22 = Messages_Common$DvmAdminFrontendFr.discount;
                  }
                  var tmp$23;
                  switch (orderType) {
                    case /* VE */2 :
                    case /* EP */7 :
                    case /* ES */8 :
                    case /* RP */9 :
                    case /* RS */10 :
                    case /* SM */11 :
                        tmp$23 = undefined;
                        break;
                    case /* CL */1 :
                    case /* VD */3 :
                    case /* RR */4 :
                    case /* RC */5 :
                    case /* PG */6 :
                    case /* TT */12 :
                        tmp$23 = /* CustomerDiscount */0;
                        break;
                    default:
                      tmp$23 = undefined;
                  }
                  return [
                          [
                            {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.customerName,
                              val: Belt_Option.getWithDefault(order.body.orderCustomerName, "-"),
                              error: tmp
                            },
                            {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.clientFirstName,
                              val: Belt_Option.getWithDefault(order.body.orderCustomerFirstName, "-")
                            }
                          ],
                          Belt_Array.concat([
                                {
                                  label: Messages_Common$DvmAdminFrontendFr.model,
                                  val: Belt_Option.getWithDefault(order.body.orderModelId, "-"),
                                  error: tmp$1,
                                  onClick: modelOnClick(order.body.orderModelId, dispatch)
                                },
                                {
                                  label: Messages_Common$DvmAdminFrontendFr.version,
                                  val: Belt_Option.getWithDefault(order.body.orderVersionId, "-"),
                                  error: tmp$2,
                                  onClick: versionOnClick(order.body.orderModelId, order.body.orderVersionId, dispatch)
                                },
                                {
                                  label: Messages_Common$DvmAdminFrontendFr.phase,
                                  val: Belt_Option.getWithDefault(order.body.orderPhase, "-")
                                },
                                {
                                  label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationNumber,
                                  val: Belt_Option.getWithDefault(order.body.orderRegistrationId, "-"),
                                  error: tmp$3
                                },
                                {
                                  label: Messages_Common$DvmAdminFrontendFr.vin,
                                  val: Belt_Option.getWithDefault(order.body.orderVIN, "-"),
                                  error: tmp$4
                                }
                              ], orderType === /* VE */2 || orderType === /* AD */13 || orderType === /* RC */5 || orderType === /* RR */4 ? [
                                  {
                                    label: Messages_Orders_Detail$DvmAdminFrontendFr.dateInputParc,
                                    val: Belt_Option.mapWithDefault(order.body.resultCalcPARCStartDate, "-", (function (param) {
                                            return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                          })),
                                    error: Belt_Option.isNone(order.body.resultCalcPARCStartDate),
                                    edit: /* ParcStartDate */1
                                  },
                                  {
                                    label: Messages_Orders_Detail$DvmAdminFrontendFr.dateOutputParc,
                                    val: Belt_Option.mapWithDefault(order.body.resultPARCEndDate, "-", (function (param) {
                                            return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                          })),
                                    edit: /* ParcEndDate */2
                                  }
                                ] : []),
                          Belt_Array.concat([
                                {
                                  label: Messages_Orders_Detail$DvmAdminFrontendFr.orderDateV2,
                                  val: Belt_Option.mapWithDefault(order.body.orderOrderDate, "-", (function (param) {
                                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                        })),
                                  error: tmp$5
                                },
                                {
                                  label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationDateV2,
                                  val: Belt_Option.mapWithDefault(order.body.orderRegistrationDate, "-", (function (param) {
                                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                        })),
                                  error: tmp$6
                                },
                                {
                                  label: Messages_Orders_Detail$DvmAdminFrontendFr.cancellationDate,
                                  val: Belt_Option.mapWithDefault(order.body.orderCancellationDate, "-", (function (param) {
                                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                        }))
                                },
                                {
                                  label: Belt_Option.mapWithDefault(order.body.resultDelivered, Messages_Orders_Detail$DvmAdminFrontendFr.deliveryDate, (function (delivered) {
                                          if (delivered) {
                                            return Messages_Orders_Detail$DvmAdminFrontendFr.deliveryDate;
                                          } else {
                                            return Messages_Orders_Detail$DvmAdminFrontendFr.desiredDeliveryV2;
                                          }
                                        })),
                                  val: Belt_Option.mapWithDefault(order.body.resultDeliveryDate, "-", (function (param) {
                                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                        })),
                                  error: tmp$7
                                },
                                {
                                  label: Messages_Orders_Detail$DvmAdminFrontendFr.lastModifShortV2,
                                  val: Belt_Option.mapWithDefault(order.body.orderLastModificationDate, "-", (function (param) {
                                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                        }))
                                },
                                {
                                  label: Messages_Orders_Detail$DvmAdminFrontendFr.madcDate,
                                  val: Belt_Option.mapWithDefault(order.body.orderMADCDate, "-", (function (param) {
                                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                        })),
                                  error: tmp$8
                                },
                                {
                                  label: Messages_Orders_Detail$DvmAdminFrontendFr.madaDate,
                                  val: Belt_Option.mapWithDefault(order.body.orderMADADate, "-", (function (param) {
                                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                        })),
                                  error: tmp$9
                                }
                              ], User_Types_Utils$DvmAdminFrontendFr.whatCountry(selectedRole) === /* Spain */1 ? [{
                                    label: Messages_Orders_Detail$DvmAdminFrontendFr.attributionDateVin,
                                    val: Belt_Option.mapWithDefault(order.body.orderAttributionVehicleDate, "-", (function (param) {
                                            return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                          }))
                                  }] : []),
                          [
                            {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceNumber,
                              val: Belt_Option.getWithDefault(order.body.orderCustomerInvoiceNumber, "-")
                            },
                            {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceClientV2,
                              val: Belt_Option.mapWithDefault(order.body.orderCustomerInvoiceDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    }))
                            },
                            {
                              label: Messages_Common$DvmAdminFrontendFr.agent,
                              val: Belt_Option.mapWithDefault(order.body.orderAgentCode, "-", (function (x) {
                                      if (x === "000") {
                                        return "-";
                                      } else {
                                        return x;
                                      }
                                    })),
                              error: orderType !== 3 && orderType !== 13 ? false : Belt_Option.mapWithDefault(order.body.orderAgentCode, true, isAgentZero)
                            },
                            {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.agentName,
                              val: Belt_Option.mapWithDefault(order.header.dealerAgentName, "-", (function (x) {
                                      if (Belt_Option.getWithDefault(order.body.orderAgentCode, "") === "000") {
                                        return "-";
                                      } else {
                                        return x;
                                      }
                                    }))
                            },
                            {
                              label: Messages_Common$DvmAdminFrontendFr.seller,
                              val: Belt_Option.getWithDefault(order.body.orderSalesmanName, "-")
                            }
                          ],
                          [
                            {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.renaultInvoiceNumber,
                              val: Belt_Option.getWithDefault(order.body.advensysInvoiceNumber, "-"),
                              error: tmp$10
                            },
                            {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceDateV2,
                              val: Belt_Option.mapWithDefault(order.body.orderRenaultInvoiceDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })),
                              error: tmp$11
                            },
                            {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.tarifNumber,
                              val: Belt_Option.getWithDefault(order.body.advensysTariffNumber, "-"),
                              error: tmp$12
                            },
                            tmp$13,
                            tmp$17,
                            {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.pvrHt,
                              val: Belt_Option.mapWithDefault(order.body.advensysNETPVR, "-", (function (eta) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, eta);
                                    })),
                              error: tmp$21
                            },
                            {
                              label: tmp$22,
                              val: Belt_Option.mapWithDefault(order.body.orderCustomerDiscount, "-", (function (eta) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, eta);
                                    })),
                              show: User_Types_Utils$DvmAdminFrontendFr.isAdmin(selectedRole) || selectedRole === /* Dealer */7 || User_Types_Utils$DvmAdminFrontendFr.isAdminDealer(selectedRole),
                              edit: tmp$23
                            },
                            {
                              label: Messages_FinancialCodes$DvmAdminFrontendFr.codeId,
                              val: Belt_Option.getWithDefault(order.body.orderEasyPack, "-"),
                              show: User_Types_Utils$DvmAdminFrontendFr.isAdmin(selectedRole) || selectedRole === /* Dealer */7 || User_Types_Utils$DvmAdminFrontendFr.isAdminDealer(selectedRole)
                            }
                          ]
                        ];
                }
                return [
                        Belt_List.toArray(Belt_List.keepMap({
                                  hd: {
                                    label: Messages_Common$DvmAdminFrontendFr.siret,
                                    val: Belt_Option.getWithDefault(order.body.orderSiret, "-")
                                  },
                                  tl: {
                                    hd: {
                                      label: Messages_Orders_Detail$DvmAdminFrontendFr.customerName,
                                      val: Belt_Option.getWithDefault(order.body.siretName, "-")
                                    },
                                    tl: {
                                      hd: Belt_Option.mapWithDefault(Belt_Option.flatMap(order.budgetBonus, (function (x) {
                                                  return x.orderBudgetType;
                                                })), undefined, (function (budget) {
                                              if (budget === "LLD" || budget === "LCD") {
                                                return {
                                                        label: Messages_Orders_Modal$DvmAdminFrontendFr.loueurID,
                                                        val: Belt_Option.getWithDefault(order.body.contractIDLeaser, "-")
                                                      };
                                              }
                                              
                                            })),
                                      tl: {
                                        hd: {
                                          label: Messages_Orders_Detail$DvmAdminFrontendFr.finalCustomer,
                                          val: Belt_Option.getWithDefault(order.body.orderSirenFinalCustomer, "-")
                                        },
                                        tl: {
                                          hd: {
                                            label: Messages_Orders_Detail$DvmAdminFrontendFr.finalCustomerName,
                                            val: Belt_Option.getWithDefault(order.body.sirenNameFinalCustomer, "-")
                                          },
                                          tl: {
                                            hd: Belt_Option.mapWithDefault(Belt_Option.flatMap(order.budgetBonus, (function (x) {
                                                        return x.orderBudgetType;
                                                      })), undefined, (function (budget) {
                                                    if (budget === "LLD" || budget === "PROT" || budget === "AVS") {
                                                      return {
                                                              label: Messages_Orders_Modal$DvmAdminFrontendFr.contractID,
                                                              val: Belt_Option.getWithDefault(order.body.contractIDFinalCustomer, "-")
                                                            };
                                                    }
                                                    
                                                  })),
                                            tl: /* [] */0
                                          }
                                        }
                                      }
                                    }
                                  }
                                }, (function (x) {
                                    return x;
                                  }))),
                        [
                          {
                            label: Messages_Common$DvmAdminFrontendFr.model,
                            val: Belt_Option.getWithDefault(order.body.orderModelId, "-"),
                            error: isStringEmpty(order.body.orderModelId),
                            onClick: modelOnClick(order.body.orderModelId, dispatch)
                          },
                          {
                            label: Messages_Common$DvmAdminFrontendFr.version,
                            val: Belt_Option.getWithDefault(order.body.orderVersionId, "-"),
                            error: isStringEmpty(order.body.orderVersionId),
                            onClick: versionOnClick(order.body.orderModelId, order.body.orderVersionId, dispatch)
                          },
                          {
                            label: Messages_Common$DvmAdminFrontendFr.phase,
                            val: Belt_Option.getWithDefault(order.body.orderPhase, "-")
                          },
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationNumber,
                            val: Belt_Option.getWithDefault(order.body.orderRegistrationId, "-")
                          },
                          {
                            label: Messages_Common$DvmAdminFrontendFr.vin,
                            val: Belt_Option.getWithDefault(order.body.orderVIN, "-"),
                            error: isStringEmpty(order.body.orderVIN)
                          }
                        ],
                        [
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.orderDateV2,
                            val: Belt_Option.mapWithDefault(order.body.orderOrderDate, "-", (function (param) {
                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                  }))
                          },
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationDateV2,
                            val: Belt_Option.mapWithDefault(order.body.orderRegistrationDate, "-", (function (param) {
                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                  }))
                          },
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.cancellationDate,
                            val: Belt_Option.mapWithDefault(order.body.orderCancellationDate, "-", (function (param) {
                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                  }))
                          },
                          {
                            label: Belt_Option.mapWithDefault(order.body.resultDelivered, Messages_Orders_Detail$DvmAdminFrontendFr.deliveryDate, (function (delivered) {
                                    if (delivered) {
                                      return Messages_Orders_Detail$DvmAdminFrontendFr.deliveryDate;
                                    } else {
                                      return Messages_Orders_Detail$DvmAdminFrontendFr.desiredDeliveryV2;
                                    }
                                  })),
                            val: Belt_Option.mapWithDefault(order.body.resultDeliveryDate, "-", (function (param) {
                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                  }))
                          },
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.lastModifShortV2,
                            val: Belt_Option.mapWithDefault(order.body.orderLastModificationDate, "-", (function (param) {
                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                  }))
                          },
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.madcDate,
                            val: Belt_Option.mapWithDefault(order.body.orderMADCDate, "-", (function (param) {
                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                  })),
                            error: Belt_Option.isNone(order.body.orderMADCDate)
                          },
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.madaDate,
                            val: Belt_Option.mapWithDefault(order.body.orderMADADate, "-", (function (param) {
                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                  }))
                          }
                        ],
                        [
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceNumber,
                            val: Belt_Option.getWithDefault(order.body.orderCustomerInvoiceNumber, "-"),
                            error: orderType === /* SO */0 && isStringEmpty(order.body.orderCustomerInvoiceNumber)
                          },
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceClientV2,
                            val: Belt_Option.mapWithDefault(order.body.orderCustomerInvoiceDate, "-", (function (param) {
                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                  })),
                            error: orderType === /* SO */0 && Belt_Option.isNone(order.body.orderCustomerInvoiceDate)
                          },
                          {
                            label: Messages_Common$DvmAdminFrontendFr.agent,
                            val: Belt_Option.mapWithDefault(order.body.orderAgentCode, "-", (function (x) {
                                    if (x === "000") {
                                      return "-";
                                    } else {
                                      return x;
                                    }
                                  }))
                          },
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.agentName,
                            val: Belt_Option.mapWithDefault(order.header.dealerAgentName, "-", (function (x) {
                                    if (Belt_Option.getWithDefault(order.body.orderAgentCode, "") === "000") {
                                      return "-";
                                    } else {
                                      return x;
                                    }
                                  }))
                          },
                          {
                            label: Messages_Common$DvmAdminFrontendFr.seller,
                            val: Belt_Option.getWithDefault(order.body.orderSalesmanName, "-")
                          }
                        ],
                        [
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.renaultInvoiceNumber,
                            val: Belt_Option.getWithDefault(order.body.advensysInvoiceNumber, "-"),
                            error: isStringEmpty(order.body.advensysInvoiceNumber)
                          },
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceDateV2,
                            val: Belt_Option.mapWithDefault(order.body.orderRenaultInvoiceDate, "-", (function (param) {
                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                  })),
                            error: Belt_Option.isNone(order.body.orderRenaultInvoiceDate)
                          },
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.tarifNumber,
                            val: Belt_Option.getWithDefault(order.body.advensysTariffNumber, "-"),
                            error: isStringEmpty(order.body.advensysTariffNumber)
                          },
                          {
                            label: Messages_Orders_Detail$DvmAdminFrontendFr.priceRefVNV2,
                            val: Belt_Option.mapWithDefault(order.body.advensysPVCHT, "-", (function (eta) {
                                    return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, eta);
                                  })),
                            error: isFloatEmptyOrZero(order.body.advensysPVCHT)
                          }
                        ]
                      ];
              }));
}

function emptyStringToNone(str) {
  return Belt_Option.mapWithDefault(str, undefined, (function (x) {
                if (x.length > 0) {
                  return x;
                }
                
              }));
}

function orderDetailResell(order, actualOrderType, lastCorrectionValues, intl, budgetIsLLD, dispatch) {
  var tmp;
  var exit = 0;
  switch (actualOrderType) {
    case /* EP */7 :
    case /* RP */9 :
    case /* AP */14 :
        exit = 2;
        break;
    case /* ES */8 :
    case /* RS */10 :
    case /* AS */15 :
        exit = 1;
        break;
    case /* SO */0 :
    case /* CL */1 :
    case /* VE */2 :
    case /* VD */3 :
    case /* RR */4 :
    case /* RC */5 :
    case /* PG */6 :
    case /* SM */11 :
    case /* TT */12 :
    case /* AD */13 :
    case /* NOTSET */16 :
        tmp = [];
        break;
    
  }
  switch (exit) {
    case 1 :
        tmp = [
          {
            label: Messages_Common$DvmAdminFrontendFr.siret,
            val: Belt_Option.getWithDefault(emptyStringToNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderSiret, (function (x) {
                            return x.siret;
                          }))), "-"),
            error: isStringEmpty(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderSiret, (function (x) {
                        return x.siret;
                      })))
          },
          {
            label: Messages_Orders_Detail$DvmAdminFrontendFr.customerName,
            val: Belt_Option.getWithDefault(emptyStringToNone(order.body.siretName), "-")
          },
          {
            label: Messages_Orders_Detail$DvmAdminFrontendFr.finalCustomer,
            val: Belt_Option.getWithDefault(emptyStringToNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderSirenFinalCustomer, (function (x) {
                            return x.sirenFinalCustomerLLD;
                          }))), "-"),
            error: budgetIsLLD ? isStringEmpty(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderSirenFinalCustomer, (function (x) {
                          return x.sirenFinalCustomerLLD;
                        }))) : false
          },
          {
            label: Messages_Orders_Detail$DvmAdminFrontendFr.finalCustomerName,
            val: Belt_Option.getWithDefault(emptyStringToNone(order.body.sirenNameFinalCustomer), "-")
          }
        ];
        break;
    case 2 :
        tmp = [
          {
            label: Messages_Orders_Detail$DvmAdminFrontendFr.customerName,
            val: Belt_Option.getWithDefault(emptyStringToNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerName, (function (x) {
                            return x.shortCustomerName;
                          }))), "-"),
            error: isStringEmpty(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerName, (function (x) {
                        return x.shortCustomerName;
                      })))
          },
          {
            label: Messages_Orders_Detail$DvmAdminFrontendFr.clientFirstName,
            val: Belt_Option.getWithDefault(emptyStringToNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerFirstName, (function (x) {
                            return x.customerFirstName;
                          }))), "-"),
            error: isStringEmpty(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerFirstName, (function (x) {
                        return x.customerFirstName;
                      })))
          }
        ];
        break;
    
  }
  return Belt_Array.concat([tmp], [
              [
                {
                  label: Messages_Common$DvmAdminFrontendFr.model,
                  val: Belt_Option.getWithDefault(order.body.orderModelId, "-"),
                  onClick: modelOnClick(order.body.orderModelId, dispatch)
                },
                {
                  label: Messages_Common$DvmAdminFrontendFr.version,
                  val: Belt_Option.getWithDefault(order.body.orderVersionId, "-"),
                  onClick: versionOnClick(order.body.orderModelId, order.body.orderVersionId, dispatch)
                },
                {
                  label: Messages_Common$DvmAdminFrontendFr.phase,
                  val: Belt_Option.getWithDefault(order.body.orderPhase, "-")
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationNumber,
                  val: Belt_Option.getWithDefault(order.body.orderRegistrationId, "-")
                },
                {
                  label: Messages_Common$DvmAdminFrontendFr.vin,
                  val: Belt_Option.getWithDefault(order.body.orderVIN, "-")
                }
              ],
              [
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.orderDateV2,
                  val: Belt_Option.mapWithDefault(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderOrderDate, (function (x) {
                              return x.orderDate;
                            })), "-", (function (param) {
                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                        })),
                  error: Belt_Option.isNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderOrderDate, (function (x) {
                              return x.orderDate;
                            })))
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationDateV2,
                  val: Belt_Option.mapWithDefault(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderRegistrationDate, (function (x) {
                              return x.newCarRegistrationDate;
                            })), "-", (function (param) {
                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                        })),
                  error: Belt_Option.isNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderRegistrationDate, (function (x) {
                              return x.newCarRegistrationDate;
                            })))
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.cancellationDate,
                  val: Belt_Option.mapWithDefault(order.body.orderCancellationDate, "-", (function (param) {
                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                        }))
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.deliveryDate,
                  val: Belt_Option.mapWithDefault(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.resultDeliveryDate, (function (x) {
                              return x.newCarDeliveryDateToCustomer;
                            })), "-", (function (param) {
                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                        })),
                  error: Belt_Option.isNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.resultDeliveryDate, (function (x) {
                              return x.newCarDeliveryDateToCustomer;
                            })))
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.madcDate,
                  val: Belt_Option.mapWithDefault(order.body.orderMADCDate, "-", (function (param) {
                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                        }))
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.madaDate,
                  val: Belt_Option.mapWithDefault(order.body.orderMADADate, "-", (function (param) {
                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                        }))
                }
              ],
              [
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceNumber,
                  val: Belt_Option.getWithDefault(emptyStringToNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerInvoiceNumber, (function (x) {
                                  return x.customerInvoiceNumber;
                                }))), "-"),
                  error: isStringEmpty(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerInvoiceNumber, (function (x) {
                              return x.customerInvoiceNumber;
                            })))
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceClientV2,
                  val: Belt_Option.mapWithDefault(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerInvoiceDate, (function (x) {
                              return x.customerInvoiceDate;
                            })), "-", (function (param) {
                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                        })),
                  error: Belt_Option.isNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerInvoiceDate, (function (x) {
                              return x.customerInvoiceDate;
                            })))
                },
                {
                  label: Messages_Common$DvmAdminFrontendFr.agent,
                  val: Belt_Option.mapWithDefault(emptyStringToNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderAgentCode, (function (x) {
                                  return x.agentCode;
                                }))), "-", (function (x) {
                          if (x === "000") {
                            return "-";
                          } else {
                            return x;
                          }
                        }))
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.agentName,
                  val: Belt_Option.mapWithDefault(order.header.dealerAgentName, "-", (function (x) {
                          if (Belt_Option.mapWithDefault(emptyStringToNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderAgentCode, (function (x) {
                                            return x.agentCode;
                                          }))), true, isAgentZero)) {
                            return "-";
                          } else {
                            return x;
                          }
                        }))
                },
                {
                  label: Messages_Common$DvmAdminFrontendFr.seller,
                  val: Belt_Option.getWithDefault(emptyStringToNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderSalesmanName, (function (x) {
                                  return x.salesmanName;
                                }))), "-")
                }
              ],
              [
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.renaultInvoiceNumber,
                  val: Belt_Option.getWithDefault(order.body.advensysInvoiceNumber, "-")
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceDateV2,
                  val: Belt_Option.mapWithDefault(order.body.orderRenaultInvoiceDate, "-", (function (param) {
                          return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                        }))
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.tarifNumber,
                  val: Belt_Option.getWithDefault(order.body.advensysTariffNumber, "-")
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.priceRefVNV2,
                  val: Belt_Option.mapWithDefault(order.body.advensysPVCHT, "-", (function (x) {
                          if (x > 0.0) {
                            return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
                          } else {
                            return "-";
                          }
                        }))
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.pvcTtc,
                  val: Belt_Option.mapWithDefault(order.body.advensysPVCTTC, "-", (function (x) {
                          if (x > 0.0) {
                            return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
                          } else {
                            return "-";
                          }
                        }))
                },
                {
                  label: Messages_Orders_Detail$DvmAdminFrontendFr.pvrHt,
                  val: Belt_Option.mapWithDefault(order.body.advensysNETPVR, "-", (function (eta) {
                          return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, eta);
                        }))
                },
                {
                  label: Messages_Common$DvmAdminFrontendFr.discountTTC,
                  val: Belt_Option.mapWithDefault(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerDiscount, (function (x) {
                              return x.customerDiscount;
                            })), "-", (function (eta) {
                          return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, eta);
                        })),
                  error: isFloatEmptyOrZero(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerDiscount, (function (x) {
                              return x.customerDiscount;
                            })))
                },
                {
                  label: Messages_FinancialCodes$DvmAdminFrontendFr.codeId,
                  val: Belt_Option.getWithDefault(emptyStringToNone(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderEasyPack, (function (x) {
                                  return x.easyPack;
                                }))), "-")
                }
              ]
            ]);
}

var DealerEditTypes;

export {
  DealerEditTypes ,
  isAgentZero ,
  isStringEmpty ,
  isFloatEmptyOrZero ,
  spainHeaders ,
  headerArray ,
  modelOnClick ,
  versionOnClick ,
  orderDetail ,
  emptyStringToNone ,
  orderDetailResell ,
}
/* RescriptReactRouter Not a pure module */
